import { parseNumber, transformModel } from '~/src/dash/api/resource-transforms';
import {
  addDomainAndTokenToUrl,
  IHttpResponse,
  restDelete,
  restGet,
  restPatch,
  restPost,
} from '~/src/dash/api/rest';

export interface ILiverampCustomIDMapPair {
  ID: number;
  CreatedAt?: string;
  UpdatedAt?: string;
  DeletedAt?: string;

  PublisherID: number;
  LiverampCustomID: number;
}

export const transformLiverampCustomIDMapPair = transformModel<ILiverampCustomIDMapPair>({
  ID: parseNumber(['ID']),
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  DeletedAt: 'DeletedAt',

  PublisherID: parseNumber(['PublisherID']),
  LiverampCustomID: parseNumber(['LiverampCustomID']),
});

// GET all LiverampCustomIDMapPairs for this publisher
// /liveramp_custom_id_map_pairs
export async function getLiverampCustomIDMapPairs(): Promise<ILiverampCustomIDMapPair[]> {
  const reqUrl = addDomainAndTokenToUrl(`/liveramp_custom_id_map_pairs`);
  return await restGet<ILiverampCustomIDMapPair[]>(reqUrl, {}).then(
    (val: IHttpResponse<ILiverampCustomIDMapPair[]>) => {
      return val.parsedBody ? val.parsedBody.map(transformLiverampCustomIDMapPair) : [];
    },
  );
}

// PATCH, DELETE a single pair
// /liveramp_custom_id_map_pairs/{liveramp_custom_id_map_pairs_id}
export async function updateLiverampCustomIDMapPair(
  pair: ILiverampCustomIDMapPair,
): Promise<ILiverampCustomIDMapPair> {
  const partialUrl = addDomainAndTokenToUrl(`/liveramp_custom_id_map_pairs/${pair.ID}`);
  const parsedPair = transformLiverampCustomIDMapPair(pair);
  return await restPatch<ILiverampCustomIDMapPair>(partialUrl, parsedPair).then(
    (val: IHttpResponse<ILiverampCustomIDMapPair>) => {
      return transformLiverampCustomIDMapPair(val.parsedBody);
    },
  );
}

export async function deleteLiverampCustomIDMapPair(
  pairID: number,
): Promise<IHttpResponse<{ status: boolean }>> {
  const reqUrl = addDomainAndTokenToUrl(`/liveramp_custom_id_map_pairs/${pairID}`);
  return await restDelete<{ status: boolean }>(reqUrl, undefined);
}

// POST a single pair
// /liveramp_custom_id_map_pairs
export async function createLiverampCustomIDMapPair(
  pair: ILiverampCustomIDMapPair,
): Promise<ILiverampCustomIDMapPair> {
  const reqUrl = addDomainAndTokenToUrl(`/liveramp_custom_id_map_pairs`);
  const parsedPair = transformLiverampCustomIDMapPair(pair);
  return await restPost<ILiverampCustomIDMapPair>(reqUrl, parsedPair).then(
    (val: IHttpResponse<ILiverampCustomIDMapPair>) => {
      return transformLiverampCustomIDMapPair(val.parsedBody);
    },
  );
}
